import React, { Fragment, useState, useEffect } from 'react'
import banner1 from './../../../assets/Home/banners/fossil-banner.webp'
import banner2 from './../../../assets/Home/banners/invicta-banner.webp'
import banner3 from './../../../assets/Home/banners/casio-banner.webp'
import banner4 from './../../../assets/Home/banners/seiko-banner.webp'
import banner5 from './../../../assets/Home/banners/citizen-banner.webp'
import styles from './Carousel.module.css'

function Carousel(){

    const [ images, _ ] = useState([banner1, banner2, banner3, banner4, banner5])
    const [ activeIndex, setActiveIndex ] = useState(0)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveIndex((prevState) => {
                return prevState === images.length - 1 ? 0 : prevState + 1
            })
        }, 3000)
        return () => clearInterval(intervalId)
    }, [images.length])

    return (
        <Fragment>
            <div className={styles['carousel-display']}>
                <img src={images[activeIndex]} alt={'Carousel Background'}/>
            </div>
            <div className={styles['carousel-controller']}>
                {images && images.map((image, index) => {
                    return (
                        <div key={index} className={`${styles['carousel-selector']} ${index === activeIndex && styles['selector-active']}`}></div>
                    )
                })}
            </div>
        </Fragment>
    )
}

export default Carousel